<template>
  <section>
    <filter-market-tabs />
  </section>
</template>

<script>
// @ is an alias to /src
import FilterMarketTabs from "@/components/FilterMarketTabs.vue";

export default {
  name: "Screener",
  components: {
    FilterMarketTabs
  }
};
</script>
